<template>
  <div class="bbe-modal">
    <div class="bbe-modal-container" v-click-outside="hideWindow">
      <h2 class="bbe-modal-container__title">{{title}}</h2>
      <i class="email-icon-close bbe-modal-container__close" @click="hideWindow()"/>
      <slot class="bbe-modal-container__content"></slot>
      <div class="bbe-modal-container-controls">
        <button class="bbe-button bbe-modal-container-controls__left-btn" @click="hideWindow()">
          Close
        </button>
        <button class="bbe-button" v-if="rightButton" @click="rightButton.action()">
          {{rightButton.text}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  name: 'ModalWindowBE',
  props: ['title', 'rightButton'],
  components: {
    VuePerfectScrollbar
  },
  methods: {
    hideWindow () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbe-modal {
    @include global-font;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: rgba($color-black, 0.56);
    z-index: 999;

    &-container {
      @include global-font;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      background: $color-white;
      min-width: 480px;
      min-height: 100px;
      position: relative;
      border-radius: 8px;

      &__title {
        margin-top: 13px;
        text-align: center;
        font-size: 17px;
        font-weight: 500;
        line-height: 20px;
        color: $color-black;
        cursor: default;
      }

      &__close {
        position: absolute;
        top: 10px;
        right: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 26px;
        height: 26px;
        font-size: 12px;
        color: $color-silver-chalice;
        border-radius: 3px;
        cursor: pointer;
        transition: .3s;

        &:hover {
          background-color: $color-gallery;
          color: $color-gray;
        }
      }

      &-controls {
        border-top: 1px solid $color-gallery;
        background-color: $color-alabaster;
        border-radius: 0 0 8px 8px;
        padding: 19px 18px;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        &__left-btn {
          background: $color-white;
          border: 1px solid $color-silver-chalice;
          box-sizing: border-box;
          color: $color-dove-gray;
          margin-right: 12px;

          &:hover {
            border-color: rgba($color-silver-chalice, 0.5);
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/ModalWindow/ModalWindow.vue